import { lazy } from "react";

const routes = [
  {
    path: "/invalid-locations/list",
    component: lazy(() => import("src/views/invalidLocation/List")),
    meta: {
      permission: "read_invalid_locations",
    },
  },
];
export default routes;
